import { PropsWithChildren } from 'react';
import usePageInitializers from '../hooks/usePageInitializers';
import { UserProps } from '@elsevier-health/osmosis-shared/types/user';

const Initializers = ({
  user,
  children,
}: PropsWithChildren<{
  user?: UserProps;
}>) => {
  // Initialize various third party scripts
  usePageInitializers({ user });

  return <>{children}</>;
};

/**
 * Component for initializing page with various scripts.
 * @param props - The component props.
 * @param props.user - The user object.
 * @param props.disableThirdPartyInitializers - Skips all third party initializers when true.
 * @param props.children - The child components.
 * @returns The initialized page.
 */
const PageInitializers = ({
  user,
  disableThirdPartyInitializers,
  children,
}: PropsWithChildren<{
  user?: UserProps;
  disableThirdPartyInitializers?: boolean;
}>) => {
  if (disableThirdPartyInitializers) {
    return <>{children}</>;
  }

  return <Initializers user={user}>{children}</Initializers>;
};

export default PageInitializers;
